import { Autos } from './../../../_entities/autos/Autos';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ContadorSemaforoService {
  gris = 0;
	verde = 0;
	rojoParpadeante = 0;
	amarilloParpadeante = 0;
	amarillo = 0;
	naranja = 0;
	rojo = 0;
	azul = 0;
	violeta = 0;
  data: Autos[];
  
  constructor() { }
}
